import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

const ColibShowcasePage = lazy(() => import('../../pages/ColibShowcasePage'));

// Access is guarded inside the page via getEnvironment().isDev (redirects to
// NOT_FOUND off dev/preview); the sidebar item is gated by isDev in dashboardDef.json.
const routes = [{ path: Location.COLIB_SHOWCASE, component: ColibShowcasePage, exact: true }];

export default routes;
